module.exports = __webpack_public_path__ + "static/media/Venomoth_gaussian2.3884855b.png";